import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { AssociativaContropartiForm } from '../../../form/associativa-controparti-form';
import { Controparte } from '../../../models/controparte';
import { SezioneContropartiResponse } from '../../../models/dto/sezione-controparti-response';
import { SezioneControparti } from '../../../models/sezioni/sezione-controparti';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';

@Component({
    selector: 'div [associativa-controparti-form-update]',
  templateUrl: '../../../form/associativa-controparti-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})
export class ContropartiAssociativaUpdateComponent extends AssociativaContropartiForm  implements OnInit {
  @Output() onReturn: EventEmitter<SezioneControparti> = new EventEmitter<SezioneControparti>();

  private idSezione: string;
  private updateUrl: string;
  private controparte: Controparte;

  constructor(@Inject(FormBuilder) campiForm: FormBuilder, @Inject(OperationsService) operationService: OperationsService, 
    @Inject(HelpersService) helpers: HelpersService, @Inject(ActivatedRoute) activatedRoute: ActivatedRoute,
    @Inject(ModalNotifyService) modalNotifyService: ModalNotifyService, @Inject(Router) router: Router ) {
      super(campiForm, operationService, helpers, activatedRoute,modalNotifyService,router);
  }
  ngOnInit() {
    //this.setTitle('Modifica controparte - Associativa');
    this.isInserimento(false);
  }

  getRequest(request: Controparte) {
    this.operationService.setControparteInSezOrdinario(request, this.updateUrl, this.idSezione).subscribe(
      response => this.datiAssociativaLegaleIncaricato(response));
  }

  datiAssociativaLegaleIncaricato(response: SezioneContropartiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(updateUrl: string, controparte: Controparte, idSezione: string) {
    this.setTitle(controparte.flagAttore ? 'Modifica attore - Associativa' :'Modifica convenuto - Associativa' )
    this.idSezione = idSezione;
    this.controparte = controparte;
    this.updateUrl = updateUrl;
    this.categoriaOriginale = controparte.categoria?.label;
    this.setCategoriaOriginale(this.categoriaOriginale); 
    this.populateSelect();
    this.createForm();
  }

  setCategoriaOriginale(categoria: string) {
    this.categoriaOriginale = categoria;
  }

  getControparte(): Controparte {
    return this.controparte;
  }

  canCheckPrimary(): boolean {
    return this.inserimento;
  }
}
